"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=asset.model.js.map